import styled from 'styled-components';

export const PageTitle = styled.h1`
  ${(p) => p.theme.text.xl};
  ${(p) => p.theme.font.bold};
`;

export const SectionTitle = styled.h2`
  ${(p) => p.theme.text.xxxl};
  ${(p) => p.theme.font.black};
`;
